import React, { useEffect, useState } from 'react';

import {
  CompareSpecs,
  CrispAndClear,
  FPVVideo,
  GogglesButtons,
  Hero,
  Measurements,
  PilotsSlider,
  PilotZoomAnimation,
  Power,
  ProductPricing,
  Silent,
  VisualExperiance,
} from 'modules/fpv-one-pilot';
import { SEO } from 'main/components';

export const FPVOnePilot: React.FC = () => {
  const [windowWidth, setWindowWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 0,
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>
      <SEO seoTitle="Drone Goggles - Immersive Goggle Experience - Orqa" />
      <section className="fpv-pilot-section">
        <Hero />
        <CrispAndClear />
        <GogglesButtons windowWidth={windowWidth} />
        <Silent />
        <VisualExperiance />
        <Power />
        <Measurements />
        <CompareSpecs />
        <FPVVideo />
        <PilotZoomAnimation />
        <PilotsSlider windowWidth={windowWidth} />
        <ProductPricing />
      </section>
    </>
  );
};
